<template>
    <CSidebar
        fixed
        :minimize="minimize"
        :show="show"
        @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
    >
        <CSidebarBrand class="d-md-down-none" to="/">
            <!--CIcon
        class="c-sidebar-brand-full"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 556 134"
      />
      <CIcon
        class="c-sidebar-brand-minimized"
        name="logo"
        size="custom-size"
        :height="35"
        viewBox="0 0 110 134"
      /-->
            <img
                src="/img/logo-white.svg"
                alt="Logo"
                class="logo" />
        </CSidebarBrand>

        <!--CRenderFunction flat :content-to-render="$options.nav"/-->
        <CRenderFunction
            v-if="navItems.length"
            flat
            :content-to-render="navItems" />

        <CSidebarMinimizer
            class="d-md-down-none"
            @click.native="$store.commit('set', ['sidebarMinimize', !minimize])"
        />
    </CSidebar>
</template>

<script>
    import nav from './_nav';

    export default {
        name: 'TheSidebar',
        nav,
        computed: {
            show() {
                return this.$store.state.sidebar.sidebarShow;
            },
            minimize() {
                return this.$store.state.sidebar.sidebarMinimize;
            },
            navItems() {
                const STATIC_SERVICES_NUM = 7;
                const settings = JSON.parse(localStorage.getItem('settings'));
                const fetchedNavItems = this.$store.getters.sidebarData;
                const fetchedNavOrdersItems = this.$store.getters.sidebarOrdersData;
                const navItems = this._getNavItems(nav[0]._children);
                if (fetchedNavItems?.length) {
                    if (settings?.is_business_admin && settings?.entities?.length) {
                        navItems.splice(navItems.length, 0, ...fetchedNavItems);
                    } else {
                        navItems.splice(STATIC_SERVICES_NUM, 0, ...fetchedNavItems);
                    }
                }
                if (fetchedNavOrdersItems?.length) {
                    if (settings?.is_business_admin && settings?.entities?.length) {
                        navItems[1].items.splice(navItems[1].items.length, 0, ...fetchedNavOrdersItems);
                    } else {
                        navItems[2].items.splice(navItems[2].items.length, 0, ...fetchedNavOrdersItems);
                    }
                }

                const result = [{
                    _name: 'CSidebarNav',
                    _children: navItems,
                }];
                return result;
            }
        },
        async mounted() {
            this.$store.dispatch('fetchSidebarData');
        },
        methods: {
            _getNavItems(_items) {
                const result = [];
                [..._items].map(item => {
                    if (typeof item === 'string') {
                        result.push(item);
                    } else if (typeof item === 'object') {
                        if (item.show !== false) {
                            if (item._name === 'CSidebarNavTitle') {
                                result.push({
                                    _name: item._name,
                                    _children: Array.isArray(item._children) ? this._getNavItems(item._children) : [],
                                });
                            } else {
                                result.push({
                                    _name: item._name,
                                    name: item.name,
                                    to: item.to,
                                    icon: item.icon || 'cil-spreadsheet',
                                    items: Array.isArray(item.items) ? this._getNavItems(item.items) : [],
                                });
                            }
                        }
                    }
                });
                return result;
            },
        },
    };
</script>
<style scoped>
.logo {
    display: block;
    width: 100%;
    max-width: 135px;
    padding: 0 10px;
}
</style>
